import React, { useContext, useState } from "react";
import { ButtonThemed as Button } from "../../../components/shared";
import { useTranslation } from "react-i18next";
import { WizardContext } from "../WizardContext";
import ArrowForward from "../../planner/icons/ArrowForward";

interface WizardFooterProps {
  onNext: () => void;
  onPrevious: () => void;
  onCancel: () => void;
}

export const WizardFooter: React.FC<WizardFooterProps> = ({
  onNext,
  onPrevious,
  onCancel,
}) => {
  const { t } = useTranslation("common");
  const { steps, currentStep } = useContext(WizardContext);
  const totalSteps = steps.length;
  const previousLabel = `< ${t("PREVIOUS")}: ${steps[currentStep - 1]}`;

  // Custom labels for each step
  let nextLabel;
  if (currentStep === totalSteps - 1) {
    nextLabel = "Finish";
  } else if (currentStep === 0) {
    nextLabel = "Continue";
  } else if (
    currentStep === 1 &&
    steps[currentStep] === "Prepare for Upcoming Lessons"
  ) {
    nextLabel = "Create assignments for rollover & prerequisite";
  } else {
    nextLabel = "Save & Continue";
  }

  return (
    <footer className="wizard-footer d-flex justify-content-end gap-1">
      {/* {currentStep > 0 ? (
        <Button onClick={onPrevious} variant="secondary">{previousLabel}</Button>
      ) : (
        <Button onClick={onCancel} variant="secondary">{t('Cancel')}</Button>
      )} */}
      <Button
        onClick={onNext}
        variant="dark"
        className="rollover-continue-button"
      >
        {nextLabel}
        <ArrowForward color="white" width={32} height={32} />
      </Button>
    </footer>
  );
};

export default WizardFooter;
